export class ConfigSingletonService {
    public static instance: ConfigSingletonService;
    public static isCreating: Boolean = false;
    public LoadingTitle: string = "Stay with us. We're almost done...";
    public static getInstance() {
        if (ConfigSingletonService.instance == null) {
            ConfigSingletonService.isCreating = true;
            ConfigSingletonService.instance = new ConfigSingletonService();
            ConfigSingletonService.isCreating = false;
        }
        return ConfigSingletonService.instance;
    }
    private config: any;
    constructor() {
        if (!ConfigSingletonService.isCreating) {
            throw new Error('You can\'t call new in Singleton instances!' +
                'Call SingletonService.getInstance() instead.');
        }
    }
    public setConfigObject(cfg: any) {
        this.config = cfg;
    }
    public getConfigObject() {
        return this.config;
    }
    public setTitle(msg: string) {
        this.LoadingTitle = msg;
    }
    public getTitle() {
        return this.LoadingTitle;
    }
}
